import styled from 'styled-components';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s2);
`;

/**
 * The columns, named once above the rows.
 *
 * The fields themselves carry no label — labelling every row would repeat
 * "Option EN / Option AR / Default" down the screen for what is one table.
 * The design's `.subhead` is the treatment for a heading over a group.
 */
/*
 * One template for the heading row and the option rows, so a column heading
 * sits over the control it names all the way down. The two control columns
 * are fixed: 64px is what `DEFAULT` needs at --fs-th, and the delete column is
 * one row-action wide.
 *
 * The heading row carries a transparent border matching the rows' so that the
 * two grids start at the same x — without it every heading sat a pixel left
 * of its column.
 */
const columns = `
  display: grid;
  grid-template-columns: 1fr 1fr 64px var(--h-btn-sm);
  align-items: center;
  gap: var(--s4);
  padding: var(--s2) var(--s3);
  border: 1px solid transparent;
`;

export const Head = styled.div`
  ${columns};
  padding-top: 0;
  padding-bottom: 0;

  span {
    font-size: var(--fs-th);
    font-weight: var(--fw-semibold);
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: var(--text-faint);
  }

  /* The two control columns are centred, so their headings are too. */
  span:nth-child(n + 3) {
    text-align: center;
  }
`;

export const Row = styled.div`
  ${columns};
  border-color: var(--line);
  border-radius: var(--r-md);
  background: var(--surface-alt);
`;

/** Centres a control in its column. */
export const Slot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

/**
 * "Which one is the default" — one answer, so a radio rather than a
 * checkbox. The design has no radio; this is its `.check` box made round,
 * on the same tokens, so it reads as the same family.
 */
export const Radio = styled.label`
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid var(--line-strong);
  border-radius: var(--r-pill);
  background: var(--surface);
  cursor: pointer;
  transition:
    border-color 0.12s,
    background-color 0.12s;

  &:hover {
    border-color: var(--text-faint);
  }

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: var(--r-pill);
    background: var(--surface);
    transition: background-color 0.12s;
  }

  &.on {
    border-color: var(--primary);

    &::after {
      background: var(--primary);
    }
  }
`;

export const Delete = styled.button`
  display: grid;
  place-items: center;
  width: var(--h-btn-sm);
  height: var(--h-btn-sm);
  padding: 0;
  border: none;
  border-radius: var(--r-sm);
  background: none;
  color: var(--text-faint);
  cursor: pointer;
  transition:
    background-color 0.12s,
    color 0.12s;

  &:hover {
    background: var(--danger-soft);
    color: var(--danger);
  }

  svg {
    width: 15px;
    height: 15px;
    stroke-width: 1.8;
  }
`;
